module.exports = __webpack_public_path__ + "static/img/mould4-1.b836d1b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/indexEditor/mould/mould4-1.png
// module id = X1YX
// module chunks = 3